const AuthCheck = function (res, router){
    if(res.data.result === false && res.data.reason === "auth"){
        router.push('/login')
    }
    return true
}
export default AuthCheck